import {
    LocalUser,
    RemoteUser,
    useIsConnected,
    useJoin,
    useLocalMicrophoneTrack,
    useLocalCameraTrack,
    usePublish,
    useRemoteUsers,
    useLocalScreenTrack,
    LocalVideoTrack
} from "agora-rtc-react";
import { Book, Book1, CallRemove, DocumentDownload, Edit, Eye, Messages, Microphone, MicrophoneSlash, More, Profile, Profile2User, Screenmirroring, SearchNormal1, Send, Send2, Sms, UserAdd, UserCirlceAdd, Video, VideoSlash } from "iconsax-react";
import React, { useContext, useEffect, useRef, useState } from "react";
import { X } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import instance from "../../../../axios/instance";
import { toast } from "react-toastify";
import { SocketContext } from "../context/SocketContext";
import formatTimestamp from "../utils/format_timestamp";


export default function GuestMeetingRoom() {

    const [loading, setLoading] = useState(false)
    const [screenShareOn, setScreenShareOn] = useState(false)
    const [viewParticipants, setViewParticipants] = useState(false)
    const [viewInviteLink, setViewInviteLink] = useState(false)
    const [isNoteOpen, setIsNoteOpen] = useState(true)
    const [isChatOpen, setIsChatOpen] = useState(false)

    const navigate = useNavigate()

    const location = useLocation()
    
    const [micOn, setMic] = useState(false);
    const [cameraOn, setCamera] = useState(false);
    const { localMicrophoneTrack } = useLocalMicrophoneTrack(micOn);
    const { localCameraTrack } = useLocalCameraTrack(cameraOn);
    const [calling, setCalling] = useState(true)
    const { screenTrack, error } = useLocalScreenTrack(screenShareOn, {}, "disable");
    usePublish([localMicrophoneTrack, localCameraTrack, screenTrack]);

    //const inviteLink = `http://localhost:5173/telemedicine/meeting/guest/${meetingData.meeting.id}`

    // production url: https://nova.careapps.net/telemedicine/meeting/guest/${meetingData.meeting.id}

    const remoteUsers = useRemoteUsers();

    // trigger message notif
    const [messageNotif, setMessageNotif] =  useState(false)

    console.log(location);
    

    // this is the main one
    // useJoin(
    //     {
    //         uid: meetingData.meeting.doctor_id,
    //         appid: "df936d67e3aa4a44829bb8ecff6e33bc", 
    //         channel: meetingData.meeting.channel_name, 
    //         token: token
    //     }, 
    //     calling
    // );

    useJoin(
        {
            uid: location.state.user,
            appid: "df936d67e3aa4a44829bb8ecff6e33bc", 
            channel: location.state.channelName, 
            token: location.state.token
        }, 
        calling
    );

    //const { meetingData, setMeetingData } = useState(true)

    function handleNoteDisplay() {
        setIsNoteOpen(!isNoteOpen)
    }

    function handleChatDisplay() {
        setMessageNotif(false)
        setIsChatOpen(!isChatOpen)
    }

    function handleEndMeeting() {
        // ask are you sure first do this when user tries to refresh browser too
        setCalling(false)
        navigate(-1)
        //setMeetingData(null)

    }

    function handleScreenSharing() {
        console.log("share screen");
        if (screenShareOn) {
            setScreenShareOn(false)
        } else {
            setScreenShareOn(true)
            
        }
    }

    function copyInviteLink() {
        navigator.clipboard.writeText(inviteLink).then(() => {
            toast.success("Invite link copied", {
                position: "bottom-right"
            })
        }).catch(err => {
            toast.error("Failed to copy link", {
                position: "bottom-right"
            })
        });
    }

    function tesFunc() {
        console.log(screenTrack);
        
    }

     // audio logic start
          const [micInstance, setMicInstance] = useState(false) // mic is off my default
          // Mute local audio
          const muteLocalAudio = (audioTrack) => {
              if (!audioTrack) return;
              audioTrack.setVolume(0);
          };
          
          // Unmute local audio
          const unmuteLocalAudio = (audioTrack) => {
              if (!audioTrack) return;
              audioTrack.setVolume(100);  // Set the volume to a reasonable volume level
          };
          // audio logic end
      
          // vidio logic start
          const [videoInstance, setVideoInstance] = useState(false) // video is off my default
          const turnOffLocalVideo = (videoTrack) => {
              if (!videoTrack) return;
              videoTrack.setEnabled(false);
          };
          
          // Unmute local video
          const turnOnLocalVideoo = (videoTrack) => {
              if (!videoTrack) return;
              videoTrack.setEnabled(true);
          };
          // video logic end



    if (loading) {
        return <div>loading call</div>
    }

    return (
        <div className="bg-white h-[100svh]"> 
           

                {/* {
                    remoteUsers.length < 1 ? 
                    <div className="w-[300px] h-[200px] absolute right-3 top-3 z-[100]">
                        {
                            !cameraOn ? <LocalUserCameraOff /> :
                            <LocalUser 
                                audioTrack={localMicrophoneTrack}
                                cameraOn={cameraOn}
                                micOn={micOn}
                                videoTrack={localCameraTrack}
                            />
                        }
                        
                    </div> : null
                } */}
               

                {/* paste here */}

                {/* <LocalVideoTrack track={screenTrack} play style={{ width: "300px", height: "300px" }} /> */}
            <div className="bg-white h-[90%]">
                {/* we will render UI with certain conditions */}

                {/* Condition 1 - if sharing screen is active */}
                {
                    screenShareOn ? 
                    <div className="grid grid-cols-12 w-full h-full">
                        <div className="col-span-9 p-4">
                            <div className="w-full h-full bg-black">
                                <LocalVideoTrack track={screenTrack} play style={{ width: "100%", height: "100%" }} />
                            </div>
                        </div>

                        <div className="col-span-3 overflow-y-scroll border-l max-h-[100%] bg-white">
                            <div className="sticky top-0 left-0 right-0 bg-white px-3 py-3">
                                <div className="font-medium">Meeting Participants ({remoteUsers.length + 1})</div>
                            </div>

                            <div className="px-4 py-3 space-y-3">
                                
                                {/* local user cam */}
                                <div className="w-full h-[200px] z-[100]">
                                    {
                                        !cameraOn || !videoInstance ? <LocalUserCameraOff /> :
                                        <LocalUser 
                                            //audioTrack={localMicrophoneTrack}
                                            cameraOn={cameraOn}
                                            micOn={micOn}
                                            videoTrack={localCameraTrack}
                                        />
                                    }
                                    
                                </div>
                                {/* local user cam */}
                                {
                                    remoteUsers.map(user => (
                                        <div key={user.uid} className="w-full h-[200px]">
                                            <RemoteUser user={user} />
                                        </div>
                                    ))
                                }

                                {/* <div className="w-full rounded-[6px] h-[200px] z-[100] bg-black"></div>
                                <div className="w-full rounded-[6px] h-[200px] z-[100] bg-black"></div>
                                <div className="w-full rounded-[6px] h-[200px] z-[100] bg-black"></div> */}
                            </div>
                        </div>
                    </div> : 
                    /* Condition 2 - if there are only 2 participants */
                    remoteUsers.length < 2 ? 
                    <div className="w-full h-full relative">
                        <div className="w-[300px] h-[200px] absolute right-3 top-3 z-[100]">
                            {
                                !cameraOn || !videoInstance ? <LocalUserCameraOff /> :
                                <LocalUser 
                                    //audioTrack={localMicrophoneTrack}
                                    cameraOn={cameraOn}
                                    micOn={micOn}
                                    videoTrack={localCameraTrack}
                                />
                            }
                        </div>

                        <div className="absolute bg-gray-100 top-0 right-0 bottom-0 left-0 flex justify-center items-center">    
                            <RemoteUser user={remoteUsers[0]} />

                            {/* <RemoteVideoTrack play style={{ width: "300px", height: "300px" }}  track={videoTracks[0]} /> */}

                            {/* {audioTracks.map(track => (
                                <RemoteAudioTrack key={track.getUserId()} play track={track} />
                            ))} */}
                        </div>
                    </div> : 
                    /* Condition 3 - if there are more than 2 participants */
                    <div className="w-full h-full grid grid-cols-12 gap-3 overflow-y-scroll justify-center items-center p-4">
                        {/* local user cam */}
                        <div className="col-span-6 h-[400px] z-[100]">
                            {
                                !cameraOn || !videoInstance ? <LocalUserCameraOff /> :
                                <LocalUser 
                                    //audioTrack={localMicrophoneTrack}
                                    cameraOn={cameraOn}
                                    micOn={micOn}
                                    videoTrack={localCameraTrack}
                                />
                            }
                            
                        </div>
                        {/* local user cam */}
                        {
                            remoteUsers.map(user => (
                                <div key={user.uid} className="col-span-6  h-[400px]">
                                    <RemoteUser user={user} />
                                </div>
                            ))
                        }

                        {/* <div className="col-span-6 h-[400px] bg-black"></div>
                        <div className="col-span-6 h-[400px] bg-black"></div>
                        <div className="col-span-6 h-[400px] bg-black"></div> */}
                    </div>
                }
            </div>
            
            <div className="p-3 h-[10%] border-t gap-3 flex items-center justify-center bg-white">
                <button onClick={() => {
                     if (micInstance) {
                        setMicInstance(false);
                        setMic(false);
                        muteLocalAudio(localMicrophoneTrack);
                      } else {
                        setMicInstance(true);
                        setMic(true);
                        unmuteLocalAudio(localMicrophoneTrack);
                      }
                }} className="w-10 h-10 rounded-full bg-[#00b0ad21] flex justify-center items-center">
                    {
                        !micOn || !micInstance ?
                        <MicrophoneSlash size={20} color="#00b0ad" variant="Bold"  /> :
                        <Microphone size={20} color="#00b0ad" variant="Bold"  />
                    }  
                </button>

                <button onClick={() => {
                    if (videoInstance) {
                        setVideoInstance(false);
                        setCamera(false);
                        turnOffLocalVideo(localCameraTrack);
                      } else {
                        setVideoInstance(true);
                        setCamera(true);
                        turnOnLocalVideoo(localCameraTrack);
                      }
                }} className="w-10 h-10 rounded-full bg-[#00b0ad21] flex justify-center items-center">
                    {
                        !cameraOn || !videoInstance ?
                        <VideoSlash size={20} color="#00b0ad" variant="Bold"  /> :
                        <Video size={20} color="#00b0ad" variant="Bold"  />
                    }      
                </button>

                <button onClick={handleScreenSharing} className="w-10 h-10 rounded-full bg-[#00b0ad21] flex justify-center items-center">
                    <Screenmirroring size={20} width="20px" height="20px" color="#00b0ad" variant="Bold"  />
                </button>

                <button onClick={handleChatDisplay} className={`w-10 h-10 relative rounded-full ${!isChatOpen ? "bg-[#00b0ad21]" : "bg-[#00b0ad]"} flex justify-center items-center`}>
                    <Messages size={20} color={!isChatOpen ? "#00b0ad" : "#fff"} variant="Bold"  />
                    {
                        messageNotif ? 
                        <div className="bg-red-500 w-3 h-3 top-0 right-0 absolute z-[1000] rounded-full"></div> : null
                    }
                </button>

                

                <div className="relative">
                    <div className={`${!viewParticipants ? "hidden" : "block"} bg-white w-[350px] absolute bottom-[70px] rounded-[8px] p-3 space-y-3`}>
                        <div className="font-medium text-[15px]">Meeting Participants ({remoteUsers.length + 1})</div>

                        {/* <div className="space-y-2">
                            <div className="flex items-center gap-3 p-3 bg-gray-100 rounded-[10px]">
                                <div className="w-10 h-10 bg-gray-300 rounded-full flex justify-center items-center">
                                    <Profile variant="Bold" size={20} color="#20232b" />
                                </div>
                                <div>
                                    <div className="text-[14px] font-medium">{meetingData.meeting.doctor_name} (You)</div>
                                    <div className="text-[12px]">Doctor</div>
                                </div>
                            </div>
                            
                            <div className="flex items-center gap-3 p-3 bg-gray-100 rounded-[10px]">
                                <div className="w-10 h-10 bg-gray-300 rounded-full flex justify-center items-center">
                                    <Profile variant="Bold" size={20} color="#20232b" />
                                </div>
                                <div>
                                    <div className="text-[14px] font-medium">{meetingData.meeting.patient_name}</div>
                                    <div className="text-[12px]">Patient</div>
                                </div>
                            </div>

                        </div> */}
                    </div>
                    <button onClick={() => setViewParticipants(!viewParticipants)} className={`w-10 h-10 rounded-full ${!viewParticipants ? "bg-[#00b0ad21]" : "bg-[#00b0ad]"} flex justify-center items-center`}>
                        <Profile2User size={20}  color={!viewParticipants ? "#00b0ad" : "#fff"} variant="Bold"  />
                    </button>
                </div>

               

                <button onClick={handleEndMeeting} className="w-10 h-10 rounded-full bg-red-500 flex justify-center items-center">
                    <CallRemove size={20} color="#fff" variant="Bold"  />
                </button>
            </div>
          

            <MeetingChat 
                roomID={location.state.meetingID}
                isChatOpen={isChatOpen} 
                onChatClose={() => setIsChatOpen(false)}
                participantName={location.state.user}
                messageNotif={data => {
                    if (data) {
                        setMessageNotif(true)
                    }
                }}
            /> 
        </div>
    )
}



function MeetingChat({ isChatOpen, onChatClose, participantName, roomID, messageNotif }) {


    const [message, setMessage] = useState("")
    const socket = useContext(SocketContext)
    const [messages, setMessages] = useState([])

    const messageRef = useRef()


    function sendMessage() {
        if (!message) {
            toast.error("Input field cannot be empty", {
                position: "bottom-right"
            })
        } else {

            const messageData = {
                user: participantName,
                roomID: roomID,
                message: message,
                createdAt: Date.now()
            }

            socket.emit("send_meeting_message", messageData)
            
            messageRef.current.value = ""
        }
    }

    function getMessages() {
        // socket.join(roomID)
        instance.post("/telemedicine/meeting/get_messages", {
            roomID: roomID
        })
        .then(response => {
            console.log(response.data);
            setMessages(response.data)
        })
        .catch(error => {
            console.log(error.response.data.message);
        })
    }

    socket.on("meeting_message_sent", data => {
        console.log("meeting_message_sent data is", data);
        messageNotif(true)
        setMessages(data.messages)
    })
   
    useEffect(() => {
        socket.emit("join_meeting_room", { roomID: roomID })
        getMessages()
    }, [isChatOpen])

    return (
        <div className={`${isChatOpen ? "right-0" : "right-[-400px]"} border-l transition-all bg-white z-[3000] flex flex-col fixed top-0 bottom-0 right-0 w-[400px]`}>

           
            <div className="flex justify-between p-3 items-center border-b">
                <div className="font-semibold">Chat</div>
                <button onClick={onChatClose}>
                    <X size={20} />    
                </button>
                
            </div>

            <div className="flex-1 p-3 space-y-3 overflow-y-scroll">
                {
                    messages.length < 1 ?
                    <div className="text-gray-500">No recent message</div> :
                    messages?.map(item => (
                        // <div key={item.id}>{item.message}</div>
                        <SenderBubble 
                            key={item.id}
                            name={item.sender_name}
                            message={item.message}
                            time={formatTimestamp(item.created_at)}
                        />
                    ))
                }
            </div>
            
             
            <div className="flex items-center p-3 gap-2 border-t">
                <input 
                    ref={messageRef} 
                    onChange={e => setMessage(e.target.value)} 
                    onKeyUp={(event) => {
                        if (event.key === "Enter") {
                            sendMessage()
                        }
                    }}
                    placeholder="Enter message..." 
                    className="py-[10px] px-4 text-[14px] bg-[#f1f1f1] outline-none rounded-full flex-1" />
                <button onClick={sendMessage} className="h-10 w-10 rounded-full bg-[#00b0ad] flex justify-center items-center">
                    <Send size={18} variant="Bold" color="#fff" />
                </button>
            </div>
    
           
        </div>
    )
}

function SenderBubble({ name, message, time, key }) {
    return (
        <div key={key} className="bg-gray-100 p-3 relative">
            <div className="font-medium text-[13px]">{name}</div>
            <div className="text-[15px] max-w-[70%]">{message}</div>
            <div className="text-[12px] absolute right-3 bottom-3">{time}</div>
        </div>
    )
}

function LocalUserCameraOff() {
    return (
        <div className="bg-[#111] w-full h-full flex justify-center items-center">
            <div className="font-semibold w-10 h-10 rounded-full bg-[#00b0ad] text-white flex justify-center items-center">Me</div>
        </div>
    )
}